import { render, staticRenderFns } from "./SupportCulturalProgram.vue?vue&type=template&id=a0e6dfe0"
import script from "./SupportCulturalProgram.vue?vue&type=script&lang=js"
export * from "./SupportCulturalProgram.vue?vue&type=script&lang=js"
import style0 from "./SupportCulturalProgram.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports